import { text } from './lib/column';
import { list } from './lib/list';

export const drive = list('drive', {
  msp: text('msp')
});
